<template>
  <section class="kiosk-configurations">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t('menu.leads'), disabled: true },
        { title: this.$t('menu.configurations'), disabled: true },
      ]">
    </Breadcrumbs>

    <KiosksTable v-if="hasReadLeadsEntitiesPermissions"
      :collapsable="false"
    />

  </section>
</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import KiosksTable from '@/components/kiosks/KiosksTable'

const leadsEntityInfoType = 110
const readAcessType = 1

export default {
  components: {
    Breadcrumbs,
    KiosksTable
  },
  computed: {
    leadsService: function () {
      return this.$store.state.services.find(s => s.url === this.$store.state.evollead_server) || null
    },
    hasReadLeadsEntitiesPermissions: function () {
      return this.leadsService && this.leadsService.user_permissions.some(p => p.info_type === leadsEntityInfoType && p.access_type >= readAcessType)
    }
  }
}

</script>
